import { Card } from "react-bootstrap";
import Moment from "react-moment";
import { BiCategory } from "react-icons/bi";
import { MdOutlineArrowRightAlt } from "react-icons/md";
import { RxCalendar } from "react-icons/rx";

const BlogPostPreview = ({ singleBlogPost }) => {
  return (
    <Card className="border mb-3">
      <Card.Img
        variant="top"
        style={{ height: 200, objectFit: "cover" }}
        src={"https://i.pravatar.cc/?img=1"}
      />
      <Card.Body>
        <div className="hstack justify-content-between mb-2">
          <div className="hstack gap-2">
            <p style={{ fontSize: 14 }} className="text-muted m-0 hstack gap-1">
              <BiCategory style={{ marginTop: 2 }} /> {singleBlogPost?.categoryName}
            </p>
            <p style={{ fontSize: 14 }} className="text-muted m-0 hstack gap-1" >
              <MdOutlineArrowRightAlt style={{ marginTop: 2 }} /> {singleBlogPost?.subCategoryName}
            </p>
          </div>
          <div className="hstack gap-2 text-muted" style={{ fontSize: 14 }}>
            <RxCalendar />
            <Moment format="DD MMM YYYY | HH:mm:ss" withTitle>
              {singleBlogPost?.createdAt}
            </Moment>
          </div>
        </div>
        <h4 className="fw-bold ">{singleBlogPost?.title}</h4>
        <div dangerouslySetInnerHTML={{ __html: singleBlogPost?.longDescription }} />
        {(singleBlogPost?.tags || [])?.length > 0 && (
          <div style={{ fontSize: 13 }} className="mt-3">
            {(singleBlogPost?.tags || []).map((tag) => (
              <span className="badge bg-primary me-2 mb-2">{tag}</span>
            ))}
          </div>
        )}
        <div className="text-end">
          <p style={{ fontSize: 14 }} className="m-0">
            {singleBlogPost?.createdByName} -: Published By
          </p>
          <div className="text-muted" style={{ fontSize: 12 }}>
            <Moment format="DD MMM YYYY | HH:mm:ss" withTitle>
              {singleBlogPost?.updatedAt}
            </Moment>
            <span> -: Updated DT</span>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default BlogPostPreview;
